import React from 'react';
import { useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';

interface CloseIconProps {
	color?: string;
	width?: string;
	height?: string;
}

export const Close: React.FC<CloseIconProps> = (props) => {
	const { palette } = useTheme();
	const { color = palette.global.ui18, width = 22, height = 22 } = props;

	return (
		<svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0.751684 0.753665C1.1437 0.361653 1.77927 0.361654 2.17128 0.753665L11.0407 9.62062L19.9937 0.667544C20.3858 0.275532 21.0213 0.275532 21.4133 0.667544C21.8054 1.05956 21.8054 1.69513 21.4133 2.08714L12.4603 11.0402L21.4134 19.9933C21.8054 20.3853 21.8054 21.0209 21.4134 21.4129C21.0213 21.8049 20.3858 21.8049 19.9938 21.4129L11.0407 12.4598L2.08763 21.2456C1.69562 21.6376 1.06004 21.6376 0.668031 21.2456C0.27602 20.8536 0.276021 20.218 0.668032 19.826L9.6211 11.0402L0.751685 2.17326C0.359673 1.78125 0.359672 1.14568 0.751684 0.753665Z"
				fill={color}
			/>
		</svg>
	);
};
